import { useState } from "react";
import { Stack } from "../../mui";
import { SelectBase } from "../SelectBase";

export const EmailComposerRecipients = (props: {
  value: string[];
  onChange: (values: string[]) => void;
  readOnly?: boolean;
}) => {
  const delimiters = [" "];
  const [email, setEmail] = useState("");

  const onInputChange = (e) => {
    let _value: string = e.target.value;

    if (delimiters.some((char) => _value.includes(char))) {
      // remove delimiters from the value
      _value = delimiters.reduce((acc, delimiter) => {
        return acc.split(delimiter).join("");
      }, _value);

      setEmail("");

      if (_value) props.onChange([...props.value!, _value]);
    } else {
      setEmail(_value);
    }
  };

  const onBlur = () => {
    if (email) props.onChange([...props.value!, email]);

    setEmail("");
  };

  const showPlaceholder = !props.readOnly;

  return (
    <Stack>
      <SelectBase
        label="Email Addresses"
        freeSolo
        multiple
        value={props.value}
        onChange={(e, values) => props.onChange([...(values as string[])])}
        inputValue={email}
        onInputChange={onInputChange}
        onBlur={onBlur}
        placeholder={showPlaceholder ? "Enter each email separated by spaces" : undefined}
        readOnly={props.readOnly}
      />
    </Stack>
  );
};
